import { render, staticRenderFns } from "./InvoiceBox.vue?vue&type=template&id=197148d8&"
import script from "./InvoiceBox.vue?vue&type=script&lang=js&"
export * from "./InvoiceBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports